module.exports = __webpack_public_path__ + "img/sub2.268aa5a7.jpg";